/**
 * API Test utility to verify headers are being sent correctly
 */

import {
  getAccessKey,
  getActionKey,
  isProxyEnabled,
  isMockDataEnabled,
  getGatewayUrl,
} from "../config/env";
import { generateTraceId } from "./uuid";

export async function testAPIHeaders() {
  console.log("=== Testing API Headers ===");

  // Get environment configuration
  const accessKey = getAccessKey();
  const actionKey = getActionKey();
  const useProxy = isProxyEnabled();
  const useMockData = isMockDataEnabled();

  console.log("Configuration:");
  console.log(
    "- Access Key:",
    accessKey ? `***${accessKey.slice(-4)}` : "NOT SET"
  );
  console.log(
    "- Action Key:",
    actionKey ? `***${actionKey.slice(-4)}` : "NOT SET"
  );
  console.log("- Use Proxy:", useProxy);
  console.log("- Use Mock Data:", useMockData);

  if (!accessKey || !actionKey) {
    console.error("⚠️ CRITICAL: API keys are not configured!");
    return false;
  }

  // Test server group endpoint
  const traceId = generateTraceId();
  const endpoint = `${getGatewayUrl()}/matrixGw/center-operations/server-group`;

  const headers = {
    "Content-Type": "application/json",
    "trace-id": traceId,
    "access-key": accessKey,
  };

  console.log("\nTest Request:");
  console.log("- Endpoint:", endpoint);
  console.log("- Headers:", {
    ...headers,
    "access-key": `***${accessKey.slice(-4)}`,
  });

  try {
    console.log("\nSending test request...");
    const response = await fetch(endpoint, {
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        centerid: "test.mytro",
      }),
    });

    console.log("\nResponse:");
    console.log("- Status:", response.status);
    console.log("- Status Text:", response.statusText);

    const responseText = await response.text();
    console.log("- Body:", responseText.substring(0, 200));

    if (response.ok) {
      console.log("✅ API call successful!");
      return true;
    } else {
      console.log("❌ API call failed with status:", response.status);
      return false;
    }
  } catch (error) {
    console.error("❌ Network error:", error);
    return false;
  }
}

// Make it available globally for testing
(window as any).testAPIHeaders = testAPIHeaders;
